import {combineReducers, createStore} from 'redux'
import { collapsedReducer } from './reducers/CollapsedReducer'
import { loadingReducer } from './reducers/LoadingReducer'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { userProfileReducer } from './reducers/UserProfileReducer'
import { configureStore } from '@reduxjs/toolkit'
import { encryptTransform } from 'redux-persist-transform-encrypt';

const rootReducer = combineReducers({
    collapsedReducer,
    loadingReducer,
    userProfileReducer
})

const encryptor = encryptTransform({
  secretKey: 'process.env.REACT_APP_SECRET_KEY',
  onError: function (error) {
    console.error(error);
  }
});

const persistConfig = {
  key: 'root',
  storage,
  transforms: [encryptor],
  blacklist: ['loadingReducer']
};


const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer)

//debug工具
// const store = configureStore({
//   reducer: persistedReducer,
// });

const persistor = persistStore(store)

export {store, persistor}
